<template>
  <v-form ref="form">
    <v-expansion-panels focusable>
      <v-expansion-panel class="mt-4 rounded-custom">
        <v-expansion-panel-header class="primary pt-0 pb-0">
          <v-list-item class="pl-0">
            <v-list-item-avatar>
              <SvgIcon
                icon="cp-password"
                fill="#c0e2e6"
                height="35px"
              ></SvgIcon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium title white--text"
                >Restaurar contraseña</v-list-item-title
              >
              <v-list-item-subtitle class="white--text"
                >Restaura tu contraseña</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="card-custom-background pa-md-4">
          <v-row class="pt-6">
            <v-col cols="12" md="10">
              <v-text-field
                v-model="practitionerPasswordForm.currentPassword"
                label="Contraseña actual"
                :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showCurrentPassword ? 'text' : 'password'"
                @click:append="showCurrentPassword = !showCurrentPassword"
                rounded
                outlined
                :rules="[
                  () =>
                    !!practitionerPasswordForm.currentPassword ||
                    'Campo requerido'
                ]"
              ></v-text-field>

              <v-text-field
                v-model="practitionerPasswordForm.password"
                label="Nueva contraseña"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                rounded
                outlined
                :rules="[
                  () => !!practitionerPasswordForm.password || 'Campo requerido'
                ]"
              ></v-text-field>

              <v-text-field
                v-model="practitionerPasswordForm.passwordConfirmed"
                label="Confirma nueva contraseña"
                outlined
                :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                rounded
                :type="showConfirmPassword ? 'text' : 'password'"
                @click:append="showConfirmPassword = !showConfirmPassword"
                :rules="[
                  () =>
                    !!practitionerPasswordForm.password || 'Campo requerido',
                  () =>
                    practitionerPasswordForm.password ==
                      practitionerPasswordForm.passwordConfirmed ||
                    'Contraseñas no coinciden'
                ]"
              ></v-text-field>

              <div class="d-flex">
                <v-spacer></v-spacer>
                <v-btn
                  color="#009c5e"
                  dark
                  rounded
                  large
                  @click="restorePassword"
                  :loading="loading"
                  >Restaurar contraseña</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog v-model="dialogSuccess" max-width="500">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="success" />
          <p class="font-weight-medium text-center title">
            Contraseña actualizada exitosamente
          </p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogSuccess = false" color="primary">Volver</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogError" max-width="500">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="error" />
          <p class="font-weight-medium text-center title">
            Ha ocurrido un error restaurando la contraseña
          </p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogError = false" color="primary">Volver</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="loading">Guardando...</v-snackbar>
  </v-form>
</template>

<script>
import SvgIcon from "@/components/SvgIcon";

export default {
  data: () => ({
    practitionerPasswordForm: {},
    showCurrentPassword: false,
    showPassword: false,
    showConfirmPassword: false,
    loading: false,
    dialogSuccess: false,
    dialogError: false
  }),
  components: { SvgIcon },
  methods: {
    async restorePassword() {
      try {
        this.loading = true;
        await this.$http.post("practitioner/change-password", {
          id: this.practitionerLogged.id,
          ...this.practitionerPasswordForm
        });
        this.dialogSuccess = true;
        this.$refs.form.reset();
      } catch (err) {
        this.dialogError = true;
      }
      this.loading = false;
    }
  },
  computed: {
    practitionerLogged() {
      return this.$store.getters["authPractitioner/getPractitioner"];
    }
  }
};
</script>

<style></style>
